/**
 * The marital status enum.
 */
export enum MaritalStatusEnum {
  CIVIL_PARTNERSHIP = 'Civil partnership',
  DIVORCED = 'Divorced',
  MARRIED = 'Married',
  SEPARATED = 'Separated',
  SINGLE = 'Single',
  WIDOWED = 'Widowed'
}
